"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrgSwitchComponent = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
const router_1 = require("@angular/router");
//INTERNAL LIBRARY BITS
const organizations_service_1 = require("./organizations.service");
const user_service_1 = require("./user.service");
const admin_service_1 = require("./admin.service");
const app_service_1 = require("./app.service");
const token_service_1 = require("./token.service");
const data_level_service_1 = require("./data-level.service");
const permission_service_1 = require("./permission.service");
const system_notification_service_1 = require("./system-notification.service");
const bid_data_filter_service_1 = require("./bid-data-filter.service");
let OrgSwitchComponent = class OrgSwitchComponent {
    constructor(_organizations, _currentUser, _bidDataFilter, _notificationService, _admin, _router, _route, _app, _http, _dataLevel, _cd, _permission) {
        this._organizations = _organizations;
        this._currentUser = _currentUser;
        this._bidDataFilter = _bidDataFilter;
        this._notificationService = _notificationService;
        this._admin = _admin;
        this._router = _router;
        this._route = _route;
        this._app = _app;
        this._http = _http;
        this._dataLevel = _dataLevel;
        this._cd = _cd;
        this._permission = _permission;
        this.searchTerm = '';
        this.permission = {};
        this.menuIcon = 'images/degree.svg';
        this.menuOpen = false;
        this.showDarkLogo = false;
        this.reportURL = '/report';
        this.dataLevelSubscription = this._dataLevel.getObservable().subscribe(r => {
            this.dataLevels = r.dataLevels.filter(dl => {
                return this.permission && this.permission['dashboard-view-data-level--' + dl.slug];
            });
        });
        this.organizationSubscription = this._organizations.getObservable().subscribe(r => {
            this.organizations = r.organizations;
        });
    }
    ngOnInit() {
        this.permission = this._permission.get();
        this.organizations = this._organizations.get();
    }
    switchOrganization(id) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._bidDataFilter.resetAllFilters();
                yield this._admin.switchOrganization(id);
                yield this._admin.clearCurrentUserFilterCache();
                yield this._router.navigate(['/refresh']);
                yield this._app.init(this._router.url.substring(0, this._router.url.indexOf('?')));
                this._notificationService.organizationSwitched();
            }
            catch (err) {
                console.log('Unable to switch org', err.message);
            }
        });
    }
    setData(opt, event) {
        return __awaiter(this, void 0, void 0, function* () {
            this._dataLevel.set(opt);
            if (opt === 'all') {
                try {
                    this._bidDataFilter.resetAllFilters();
                    yield this._http.get(this.reportURL + '/defaultIsRestricted').toPromise();
                    yield this._admin.clearCurrentUserFilterCache();
                    yield this._router.navigate(['/refresh']);
                    yield this._app.init(this._router.url.substring(0, this._router.url.indexOf('?')));
                }
                catch (err) {
                    console.error('Unable to set Data switch', err);
                }
            }
            else {
                event.stopPropagation();
            }
        });
    }
    onButtonMouseOver() {
        this.menuIcon = 'images/degree.svg';
    }
    onButtonMouseOut() {
        this.menuIcon = 'images/degree.svg';
    }
    ngOnDestroy() {
        // unsubscribe to ensure no memory leaks
        this.dataLevelSubscription.unsubscribe();
        this.organizationSubscription.unsubscribe();
    }
};
exports.OrgSwitchComponent = OrgSwitchComponent;
exports.OrgSwitchComponent = OrgSwitchComponent = __decorate([
    (0, core_1.Component)({
        selector: 'my-org-switch',
        templateUrl: 'app/org-switch.component.html',
        styleUrls: ['styles/app.component.css'],
    }),
    __metadata("design:paramtypes", [organizations_service_1.OrganizationsService,
        user_service_1.UserService,
        bid_data_filter_service_1.BidDataFilterService,
        system_notification_service_1.SystemNotificationService,
        admin_service_1.AdminService,
        router_1.Router,
        router_1.ActivatedRoute,
        app_service_1.AppService,
        token_service_1.TokenService,
        data_level_service_1.DataLevelService,
        core_1.ChangeDetectorRef,
        permission_service_1.PermissionService])
], OrgSwitchComponent);
//# sourceMappingURL=org-switch.component.js.map